var jq = jQuery.noConflict();

var companyVars = JSON.parse(document.getElementById("companyVars").innerText),
    asset_url = companyVars.asset_url,
    website_base_url = companyVars.website_base_url,
    ir_base_url = companyVars.ir_base_url,
    hCaptchaSiteKey = companyVars.hCaptchaSiteKey,
    isQmod = companyVars.isQmod;



// Fires on click or enter keypress
jq.fn.accessibleClick = function (handler) {
    jq(this).on('click keyup', function (event) {
        if (event.type === 'keyup') {
            var code = event.which;
            // Don't consider it a click if we don't press enter or spacebar
            if ((code !== 32) && (code !== 13)) {
                return false;
            }
        }
        handler.call(this, event);
    });
};
    
var captchaIDs = {}; // Holds all hCaptcha elements so that we can use the correct response when there are multiples on a page
function hCaptchaOnLoad () {
    // Add hcaptcha to all forms on a page
     jq('.h-captcha').each(function () {
        var form = jq(this).closest('form');
        window.captchaIDs[form.id] = hcaptcha.render(this.id, {
            "sitekey" : window.hCaptchaSiteKey,
            "callback": function (token) {
                jq('<input>', {
                    type: 'hidden',
                    name: 'h-captcha-response',
                    value: token
                }).appendTo(form);
                form.submit();
            }
        });
    }); 
}

// Main document ready scripts
jq(document).ready(function () {
    // Add noopener to all links that open in a new tab.
    jq('a[target="_blank"]').each(function () {
        var linkRel = jq(this).attr('rel');
        if (!linkRel || (linkRel && linkRel.indexOf('noopener') == -1)) {
            var newRel = linkRel === undefined ? '' : linkRel;
            newRel += linkRel && linkRel.length ? ' noopener' : 'noopener';
            jq(this).attr('rel', newRel);
        }
        // Add descriptive text for screen readers if there's not already a title attr set
        if (this.getAttribute('title') === null) {
            this.setAttribute('title', 'Opens in a new window');
        }
    });
    addRequiredAsteriskToLabels();
    
    // Scroll more home hero button
    var scrollMore = document.getElementById("scroll-more");
    if (scrollMore) {
        jq(scrollMore).accessibleClick(function (e) {
            e.preventDefault();
            var target = jq(this).closest(".home-hero").siblings(".module").first();
            jq("html,body").animate({
                scrollTop: target.offset().top - jq("#header").height()
            }, "slow");
        });
    }
    
    jq(".mobile-nav-trigger").click(function (){
        jq(".main-nav").css("height", "auto");
    });
    
    jq("#header.affixed").affix({
        offset:{
            top: 1
        }
    });
    
    //Video Play/Pause Buttons
    var videoBtns = document.querySelectorAll('.video-control-btn');
    videoBtns.forEach(function(el) {
        // get video id from attribute 'data-target'
        var targetVideo = document.getElementById(el.dataset.target);
        if (targetVideo) {
          jq(el).click(function(e) {
            if (targetVideo.paused) {
              targetVideo.play();
              //Controls don't show by default to match designs
              //On play, we need to hide the designed play/pause button and shows the controls
              if (targetVideo.classList.contains('show-controls-on-play')) {
                el.classList.add('hide');  
                targetVideo.setAttribute('controls', '');
              }
              // The label names the action the button performs next, which is
              // what carries the state now that aria-pressed is gone. It has to
              // keep saying "Background Video" to match the name the markup
              // ships with, otherwise the button renames itself on first use.
              el.setAttribute('aria-label', 'Pause Background Video');
            } else {
              targetVideo.pause();
              el.setAttribute('aria-label', 'Play Background Video');
            }
            el.classList.toggle('paused');
          });
        }
    });
    
    //Circle Stat with Percentage Animation
    var divPercentage = jq(".stats-row-w-percents");
    if(divPercentage.length) {
        jq(document).bind("scroll", function (ev) {
            var scrollOffset = jq(document).scrollTop();
            var containerOffset = jq(".stats-row-w-percents").offset().top - window.innerHeight;
            if (scrollOffset > containerOffset) {
                jq(".stats-row-w-percents .stat").each(function () {
                    var percDiv = jq(this).find(".number"),
                    svgElm = jq(this).find(".circle"),
                    percentNumber = jq(this).attr("data-percent");
                    svgElm.attr("stroke-dasharray", percentNumber + ", 100");
                    svgElm.addClass("active");
                    jq({percentage: 0}).stop(true).animate({percentage: percentNumber}, {
                        duration : 2000,
                        step: function () {
                        var percentageVal = Math.round(this.percentage);
                        percDiv.text(percentageVal + "%");
                    }
                    }).promise().done(function () {
                        percDiv.text(percentNumber + "%");
                    });
                });
                jq(document).unbind("scroll");
            }
        });
    }
    
    var subNav = jq(".sub-navigation.affixed");
    if(subNav.length) {
        jq(subNav).affix({
            offset: { 
                top: jq(".sub-navigation").offset().top - jq("#header").outerHeight()
            }
        });
    }

    var menuRight = document.getElementById("mobile-nav"),
    showRight = document.getElementById("showRight");
    
    jq.fn.openMobileRightMenu = function() {
        toggleMenuKeybind();
        jq(this).toggleClass("active");
        jq("body").toggleClass("push-to-left");
        jq(menuRight).toggleClass("cbp-spmenu-open");
        disableOther("showRight");
    }

    function disableOther(button) {
        if (button !== "showRight") {
            jq(showRight).toggleClass("disabled");
        }
    }
    
    /**
     * This function handles keydown events when a full screen nav is present, allowing
     * the navigation to be closed by pressing the esc key
     */
     function toggleMenuKeybind() {
        var $body = jq('body');    
        if ($body.hasClass('push-to-left')) {
            $body.off("keydown");
        } else {
            $body.on("keydown", function (e) {
                if (e.which == 27) {
                    jq(".main-nav").toggleClass("active");
                    jq(showRight).toggleClass('active');
                    jq("body").toggleClass("push-to-left");
                    jq(menuRight).toggleClass("cbp-spmenu-open");
                    disableOther("showRight");
                    $body.off("keydown");
                }
            });
        }
    }

    // Basic Form Validation
    var validator = jq(".validate-form");
    validator.each(function () {
        var $form = jq(this);
        var formID = $form.attr('id');
        jq(this).validate({
            rules: {
                password_confirm: {
                    equalTo: "#password",
                    messages: {
                        equalTo: "Passwords must be the same"
                    }
                }
            },
            errorPlacement: function (error, element) {
                error.appendTo(element.parent());
            },
            // Fields are only marked invalid once validation has actually run, so
            // nothing is announced as invalid before the visitor submits.
            highlight: function (element, errorClass, validClass) {
                jq.validator.defaults.highlight.call(this, element, errorClass, validClass);
                jq(element).attr('aria-invalid', 'true');
            },
            unhighlight: function (element, errorClass, validClass) {
                jq.validator.defaults.unhighlight.call(this, element, errorClass, validClass);
                jq(element).removeAttr('aria-invalid');
            },
            submitHandler: function (form) {
                if (hcaptcha.getResponse(window.captchaIDs[formID])) {
                    form.submit();
                } else {
                    hcaptcha.reset(window.captchaIDs[formID]);
                    hcaptcha.execute(window.captchaIDs[formID]);
                }
            }
        });
    });
    
    jq.validator.methods.email = function (value, element) {
      return this.optional(element) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value);
    }
    
    jq(".fancybox").fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: "600"
    });
    jq(".fancybox-sec-filing").fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: "900"
    });
    
    jq(".fancybox-bio").fancybox({
        helpers: {
            overlay: {
                locked: true
            }
        },
        minHeight: "0"
    });
    
    jq(".fancybox-modal").fancybox({
        width: 970,
        autoSize: false,
        height: "auto"
    });
    
    jq(".fancybox\\.iframe").fancybox({
        type: "iframe",
        iframe : {
            css : {
                width : "80%",
                maxWidth: "1024px",
            }
        }
    });
    
    //Bootstrap Select
    jq(".selectpicker").selectpicker({
        iconBase: "DIN",
        tickIcon: "no-icon", 
        dropupAuto: false, 
        display: "static"
    });
    
    //File input
    var fileInput = jq(".file-text input");
    fileInput.change(function (e){
        $this = jq(this);
        var val = $this.val().split("\\");
        var length = val.length;
        var filename = val[length-1];
        jq(this).parent(".file-text").children(".text-wrapper").text(filename);
    });

    // SEC Filing Filters - auto submit form
    jq("#sec-filing-filter select").on("change", function (e) {
        jq(this).closest("form").submit(); 
    });
    
    var $filterSelect = jq(".row-filter .selectpicker");
    if ($filterSelect.length) {
        $filterSelect.on("change", function () {
            var url = window.location.protocol + "//" + window.location.hostname + window.location.pathname;
            var query = "";
            jq(".row-filter .selectpicker").each(function () {
                var prefix = "&";
                if (query.length === 0) {
                    prefix = "?";
                }
                if (jq(this).val() != -1) {
                    query += prefix + jq(this).attr("name") + "=" + jq(this).val();
                }
            });
            url = url + query;
            if (!query) {
            	var full_url = url + "?year=" + jq(this).val();
            	if (window.location.href != full_url) {
            		window.location.href = full_url;
            	}
            } else {
            	if (window.location.href != url) {
            		window.location.href = url;
            	}
            }
       });
    }
    
    // Resources module
    if (jq(".module-resources-page").length) {
        var viewModel = new ViewModel(JSON.parse(document.getElementById("resourcesVm").innerText));
    }
    
    // News slider
    if (jq(".news-slider").length) {
        jq(".news-slider").slick(JSON.parse(document.getElementById("newsSlickOptions").innerText));
    }
    
    // SEC Filings expand
    jq(".spr-expandable").hide();
    jq(".spr-toggle-expandable").click(function () {
    	jq(this).next(".spr-expandable").toggle("blind");
    });
    
    // Crisis Messaging
    var $majorAnnouncement = jq('#majorAnnouncement');
    var majorAnnouncementCookieName = "eqMajorAnnouncement";
    if ($majorAnnouncement.length) {
        var majorAnnouncementTimestamp = $majorAnnouncement.data("timestamp");
        var majorAnnouncementCookie = Cookies.get(majorAnnouncementCookieName);
        if (majorAnnouncementCookie != majorAnnouncementTimestamp) {
            jq.fancybox.open({
                src: '#majorAnnouncement',
                type: 'inline',
                touch: window.outerWidth < 768,
                beforeLoad: function () {
                    // Add an aria-label to the modal
                    var fancyboxContainer = jq.fancybox.getInstance().$refs.container;
                    fancyboxContainer.attr('aria-label', 'Announcement');
                },
                afterLoad: function () {
                    // Remove main content visibility to screen readers
                    jq('.general-wrapper').attr('aria-hidden', true);
                },
                afterClose: function () {
                    jq('.general-wrapper').attr('aria-hidden', false);
                }
            });
            // Expires should be set to a number of days
            Cookies.set(majorAnnouncementCookieName, majorAnnouncementTimestamp, { secure: true, domain: window.location.hostname, expires: 7 });
        }
    }
    
    // Add Class to body if there is a scoll bar in the page
    if (jq(document).width() < jq(window).outerWidth()) { 
        jq('body').addClass('scrollbar');
    }
    
    // Add Role to bootstrap select dropdown-items
    jq('.bootstrap-select').on('loaded.bs.select', function(evt) {
        document.querySelectorAll('.dropdown-menu > .inner').forEach(function (el) {
            el.setAttribute('role', '');
            var childEl = el.querySelector('.dropdown-item');
            if (childEl) {
                childEl.setAttribute('role', '');
            }
        });
    });
    jq('.bootstrap-select').on('shown.bs.select', function(evt) {
        document.querySelectorAll('.dropdown-item').forEach(function (el) {
            el.setAttribute('role', '');
        });
    });
    
    // Fix accessibility issue for main navigation and sub navigation triggers on mobile
    function resize_events() {
        if (window.innerWidth <= 991) {
            jq('.mobile-nav-trigger').attr('tabindex', 0);
            jq('.mobile-sub-nav-trigger').attr('tabindex', 0);
            jq('.has-children ul li a').attr('tabindex', '-1');
            // keeping this in case it needs to come back
            // if (jq('.cbp-spmenu').hasClass('cbp-spmenu-open')) {
            //     jq('.cbp-spmenu > .main-menu > li > a').attr('tabindex', 0);
            // } else {
            //     jq('.cbp-spmenu > .main-menu > li > a').attr('tabindex', -1);
            // }
        } else {
            jq('.mobile-nav-trigger').attr('tabindex', '');
            jq('.mobile-sub-nav-trigger').attr('tabindex', '');
            jq('.has-children ul li a').attr('tabindex', '');
            //jq('.cbp-spmenu > .main-menu > li > a').attr('tabindex', 0);
        }
    }
    // Call resize_events() on load
    resize_events();

    jq(window).resize(function(evt) {
        resize_events();
    });

    // Enable accessible clicking on mobile navs and subnavs
    jq('.mobile-nav-trigger').accessibleClick(function(evt) {
        jq(this).openMobileRightMenu();
        resize_events();
        return false;
    });
    jq('ul.main-menu > li.has-children').on('click', function() {
        // This is the mobile accordion. On desktop the submenu opens on hover /
        // focus-within, and .active is what paints the current-section underline,
        // so letting a desktop click through here leaves the item looking like
        // the page you are on. The nav parent is a real <button> now, so its
        // Enter and Space both arrive as clicks and bubble to this handler.
        if (!jq('#mobile-nav').hasClass('cbp-spmenu-open')) {
            return;
        }
        if (jq(this).hasClass('active')) {
            jq(this).removeClass('active'); 
        } else {
            jq(this).addClass('active'); 
        }
           
    });

    jq('.mobile-sub-nav-trigger').accessibleClick(function(evt) {
        // We want to use the accessibleClick method so that the logic surrounding
        // keys is consistent; however, avoid recursion by causing an infinite click loop
        if (evt.type != 'click') {
            jq(this).click();
            return false;
        }
    });

    setTimeout(function() {
        jq('.qmod-legend li').each(function(i) {
            jq(this).attr('tabindex', 0);
            jq(this).accessibleClick(function(evt) {
                // We want to use the accessibleClick method so that the logic surrounding
                // keys is consistent; however, avoid recursion by causing an infinite click loop
                if (evt.type != 'click') {
                    jq(this).click();
                    return false;
                }
            });
        });
    }, 1000);
}); // end document.ready

// Adds asterisk to the labels of required form inputs
function addRequiredAsteriskToLabels() {
    jq("form .required").siblings("label").each(function () {
        var currentText = jq(this).text();
        jq(this).text(currentText + "*");
    });
}

//Smooth scroll to
function goToByScroll(id, callback) {
    jq("html,body").animate({
        scrollTop: jq(id).offset().top
    }, "slow", "swing", callback);
}
jq(".smooth").click(function () {
    goToByScroll(jq(this).attr("href"));
    return false;
});
// Event handler for changes to checkboxes and radio buttons in all groups
jq(document).on("change", 'ul.checkboxes input[type="checkbox"], ul.radios input[type="radio"]', function () {
    let ul = jq(this).closest("ul.checkboxes, ul.radios");

    // Update ARIA attributes for accessibility
    if (jq(this).attr("type") === "radio") {
        // Set aria-checked for all radio buttons in the group
        ul.find('input[type="radio"]').attr("aria-checked", "false");
        jq(this).attr("aria-checked", "true");
    } else {
        jq(this).attr("aria-checked", this.checked);
    }

    // Check if any input in this group is checked
    if (ul.find("input:checked").length > 0) {
        // If an input is checked, remove the border and error message
        ul.css("border", "");
        ul.siblings(".eq-error").remove();
    }
});

// Initialize ARIA attributes on page load
jq('ul.checkboxes input[type="checkbox"], ul.radios input[type="radio"]').each(function () {
    jq(this).attr("aria-checked", this.checked);
});
    
// Checkbox Groups
var update_sec_checkboxes = function () {
    if (jq("#ir-sec-all").is(":checked")) {
        jq(".ir-sec-sub").prop("checked", true).prop("disabled", true);
    } else {
        jq(".ir-sec-sub").prop("disabled", false).prop("checked", false);
    }
}
jq("#ir-sec-all").change(update_sec_checkboxes);
if (jq("#ir-sec-all").is(":checked")) {
    jq(".ir-sec-sub").prop("checked", true).prop("disabled", true);
}

// Timeline
var $timelineEl = jq(".module-timeline");
if ($timelineEl.length) {
    var timeline = {
        resizePoints: function () {
            if (jq(window).outerWidth() < 768) return;
            jq(".point-wrapper").each(function () {
                  var point = jq(this).find(".point");
                  jq(this).css("height", point.outerHeight()/1.2);
                });
        }
    };
    // Once we"re done resizing, calculate the height for the points.
    var resizeTimer;
    jq(window).on("resize", function (e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(timeline.resizePoints, 250);
    });
    timeline.resizePoints();
}
//Add Class to body if page has scrollbar
jq(window).on("resize", function (e) {
    if (jq(document).width() < jq(window).outerWidth()) { 
        jq('body').addClass('scrollbar');
    } else {
        jq('body').removeClass('scrollbar');
    }
});
var $filterSelect = jq(".eq-select");
    if ($filterSelect.length) {
        $filterSelect.on("change", function () {
            var url = window.location.protocol + "//" + window.location.hostname + window.location.pathname;
            var query = "";
            jq(".eq-select").each(function () {
                var prefix = "&";
                if (query.length === 0) {
                    prefix = "?";
                }
                if (jq(this).val() != -1) {
                    query += prefix + jq(this).attr("name") + "=" + jq(this).val();
                }
            });
            url = url + query;
            if (!query) {
                var full_url = url + "?year=" + jq(this).val();
                if (window.location.href != full_url) {
                    window.location.href = full_url;
                }
            } else {
                if (window.location.href != url) {
                    window.location.href = url;
                }
            }
        });
    }